import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";

const EnrollmentConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const courseTitle = location.state?.courseTitle || "the course";

  return (
    <>
      <Breadcrumb title="Enrollment Confirmation" />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4 py-8">
        <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 max-w-lg w-full">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div className="bg-green-100 rounded-full p-3">
              <FaCheckCircle className="text-5xl text-green-500" />
            </div>
          </div>

          {/* Header */}
          <h1 className="text-2xl md:text-3xl font-bold mb-3 text-gray-900 text-center">
            Enrollment Confirmed!
          </h1>

          <p className="text-center text-gray-600 mb-6">
            Your request has been received successfully
          </p>

          {/* Info Card */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-[#009fe3] rounded-lg p-4 mb-6 space-y-3">
            <p className="text-gray-700">
              📚 <strong>Course:</strong> {courseTitle}
            </p>
            <p className="text-gray-700">
              ✅ Thank you for joining{" "}
              <strong className="text-[#009fe3]">Guideline2Germany!</strong>
            </p>
            <p className="text-gray-700">
              Our team will review your payment and confirm your enrollment
              soon.
            </p>
            <p className="text-gray-700">
              Check your email for updates and next steps.
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={() => navigate("/student/student-dashboard")}
            className="w-full py-3 bg-[#009fe3] text-white rounded-lg hover:bg-[#007cb5] font-semibold transition-all hover:shadow-lg transform hover:-translate-y-0.5"
          >
            Go to Dashboard →
          </button>

          {/* Footer Note */}
          <p className="text-center text-sm text-gray-500 mt-4">
            Need help?{" "}
            <a
              href="mailto:info@guideline2germany.com"
              className="text-[#009fe3] hover:underline"
            >
              Contact G2G Support
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default EnrollmentConfirmation;
